import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSecretPhrase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"secret-phrase, code, private-phrase"} maskId="square-filled-radius-0-stroke-1-IconSecretPhrase"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 8H11V9H6V8ZM13 8V9H18V8H13ZM6 11.5H11V12.5H6V11.5ZM13 11.5V12.5H18V11.5H13ZM6 15H11V16H6V15ZM13 15V16H18V15H13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSecretPhrase;
